import { render } from "./red1.vue?vue&type=template&id=6bc2eba6&scoped=true"
import script from "./red1.vue?vue&type=script&lang=js"
export * from "./red1.vue?vue&type=script&lang=js"

import "./red1.vue?vue&type=style&index=0&id=6bc2eba6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc2eba6"]])

export default __exports__